"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var r = require("revalidate");
var combineValidators = r.combineValidators;
var isRequired = r.isRequired;
exports.districtSchoolValidator = combineValidators({
    district: isRequired({ message: "districtRequired" }),
    school: isRequired({ message: "isRequired" }),
});
//# sourceMappingURL=districtSchool.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/districtSchool/districtSchool.js
// module id = 438
// module chunks = 22